import PropTypes from 'prop-types';

// TODO: Figure out a better place for these prop types to live

// Shop specific for now... will adjust with design
export const imagePropType = {
  id: PropTypes.number,
  imageUrl: PropTypes.string,
};

export const orderItemPropType = {
  id: PropTypes.number,
  quantity: PropTypes.number,
  name: PropTypes.string,
  slug: PropTypes.string,
  subTitle: PropTypes.string,
  price: PropTypes.number,
  amount: PropTypes.number,
  images: PropTypes.arrayOf(PropTypes.string),
};

export const orderPropType = {
  number: PropTypes.string,
  state: PropTypes.string,
  createdAt: PropTypes.string,
  subtotal: PropTypes.number,
  shipping: PropTypes.number,
  air_filter_shipping: PropTypes.number,
  glowforge_shipping: PropTypes.number,
  promoDiscounts: PropTypes.number,
  salesTax: PropTypes.number,
  total: PropTypes.number,
  email: PropTypes.string,
  billingMatch: PropTypes.bool,
  items: PropTypes.arrayOf(PropTypes.shape(orderItemPropType)),
  adjustments: PropTypes.arrayOf(PropTypes.shape({
    amount: PropTypes.number,
    label: PropTypes.string,
  })),
};



// WEBPACK FOOTER //
// ./app/store/selectors/products.js